import { useQuery } from 'react-query';
import { V2 } from 'types/swagger/clarifai-api';
import { fetch } from 'utils/request';

export const useListModelTypes = ({ isEnabled = false }: { isEnabled?: boolean }) => {
  return useQuery(
    ['V2ListModelTypes2'],
    async () => {
      return fetch<V2.V2ListModelTypes2.ResponseBody>({
        path: '/api/_api/v2/models/types',
        method: 'GET',
      });
    },
    {
      enabled: isEnabled,
    },
  );
};
